<template>
    <main-content-wrapper>
        <h1 class="text-md-center font-weight-regular">
            REGISTRACIJA
            <span>Registrirajte se brez Tuš Cash & Carry klub kartice.</span>
        </h1>

        <v-layout justify-center row wrap fill-height >
            <v-flex xs12 md6 pl-5 pr-5 pt-4 pb-4 class="border">
                <split-content text="Podatki o podjetju"/>
                <empty-space />
                <v-flex xs12 sm12>
                    <v-form v-model="valid" @submit.prevent="" ref="formCompany">
                        <vat-number required label="Vpišite davčno številko podjetja" :error-messages="noCompanyMsg" v-model="vat" @blur="updateCompany()" ref="company_vat" />
                    </v-form>
                </v-flex>
                <inline-loader v-if="loadingCompanyInfo" />
                <v-flex xs12 sm12 v-if="company">
                    <b>{{ company.name }}</b><br />
                    {{ company.address }}
                </v-flex>
                <empty-space />
                <split-content text="Podatki za prijavo"/>
                <empty-space />
                <v-flex xs12 sm12>
                    <v-form v-model="valid" @submit.prevent="" ref="formAccount">
                        <v-alert
                                :value="invalid_no_cond"
                                type="error"
                        >
                            Za nadaljevanje se je potrebno strinjati s pogoji poslovanja.
                        </v-alert>
                        <v-alert
                                :value="error_creating!=null"
                                type="error"
                        >
                            {{ error_creating }}
                        </v-alert>

                        <email-field v-model="email" label="Vpišite vaš e-naslov" :error-messages="email_error_messages" :rules="[checkEmail]" ref="email_input" required />
                        <password-field v-model="password" :rules="newPasswordRules" label="Izberite geslo" required/>
                        <password-field v-model="password_again" :rules="[checkNewPasswordAgain]" label="Ponovno vpišite geslo" required/>
                        <v-checkbox
                                v-model="confirm_cond"
                                required
                        >
                            <div slot="label">
                                Strinjam se s <a target="_blank" href="https://www.tuscc.si/splosni-pogoji-poslovanja" v-on:click.stop="" class="terms">splošnimi pogoji poslovanja</a>.
                            </div>
                        </v-checkbox>
                    </v-form>
                </v-flex>
                <v-btn depressed large block color="primary_action" @click="createAccount" :loading="loading">Potrjujem vpisane podatke</v-btn>
                <empty-space />
                <p class="text-md-center">
                    Že imate račun? <router-link :to="loginRoute">Prijava</router-link>
                </p>
            </v-flex>
        </v-layout>
    </main-content-wrapper>
</template>

<script>
    import MainContentWrapper from "../components/MainContentWrapper";
    import SplitContent from "../components/SplitContent";
    import EmptySpace from "../components/EmptySpace";
    import PasswordField from "../components/PasswordField";
    import EmailField from "../components/EmailField";
    import VatNumber from "../components/VatNumber";
    import {registrationService, userService} from "../services";
    import InlineLoader from "../components/InlineLoader";
    import validations from "../components/validations";
    import Router from "../router";


    export default {
        name: "CreateAccountNoCard",
        data: vm => ({
            vat: null,
            loading: false,
            loadingCompanyInfo: false,
            invalid_no_cond: false,
            confirm_cond: false,
            noCompanyMsg: null,
            company: null,
            email: null,
            password: null,
            password_again: null,
            email_error_messages: null,
            error_creating: null
        }),
        components: {InlineLoader, SplitContent, MainContentWrapper, EmptySpace, PasswordField, EmailField, VatNumber},
        computed: {
            loginRoute(){
                if (this.$route.query.next) {
                    return {path: '/', query: {next: this.$route.query.next}};
                }
                return {path: '/'};
            }
        },
        methods: {
            checkEmail(v){
                this.email_error_messages = [];
                let noError = validations.checkEmailAll(v);
                if (noError === true){
                    userService.checkEmail(v).then(
                        data => {
                            this.email_error_messages = null;
                        },
                        error => {
                            if (error.message) {
                                this.email_error_messages = [error.message];
                            } else {
                                this.email_error_messages = ['Napaka pri preverjanju naslova.'];
                            }
                        }
                    );
                    return true;
                }
                return noError;
            },
            checkNewPasswordAgain(v) {
                return validations.newPasswordCheckAgain(v, this.password);
            },
            updateCompany(){
                this.company = null;
                if (this.vat.length == 8) {
                    this.loadingCompanyInfo = true;
                    registrationService.companyByVAT(this.vat).then((data) => {
                        this.noCompanyMsg = '';
                        this.company = data;
                    }, (error) => {
                        this.noCompanyMsg = error.message;
                    }).finally(() => {
                        this.loadingCompanyInfo = false;
                    });
                }
            },
            createAccount(){
                let isValidCompany = this.$refs.formCompany.validate();
                let isValidAccount = this.$refs.formAccount.validate();

                this.invalid_no_cond = this.confirm_cond == false;
                if (isValidCompany && isValidAccount && this.confirm_cond && this.company){
                    this.loading = true;
                    this.error_creating = null;
                    userService.createAccountForCompany(this.email, this.password, this.company.registration_number).then(
                        (data) => {
                            this.$store.dispatch('application/emailSentMessage', {
                                'title': 'Registracijo ste že skoraj zaključili.',
                                'text': 'Za dokončanje postopka potrdite povezavo, ki smo jo poslali na vaš e-naslov.'
                            })
                        },
                        (error) => {
                            this.error_creating = error.message;
                        }
                    ).finally(()=>{
                        this.loading = false;
                    });
                }
            }
        }
    }
</script>

<style scoped>

</style>
